import { ChakraProvider } from '@chakra-ui/react'
import React from 'react'
import Layout from './components/layout'
import { extendTheme } from '@chakra-ui/react'
import "@fontsource/roboto"

const config={
  initialColorMode:"dark",
  useSystemColorMode: false,
}

const Text= {
  baseStyle:{
    fontWeight:300,
    color:'text',
    fontFamily: 'Roboto',
    mb:3,
    fontSize: 'md'
  },
  sizes:{
    sm:{
      fontSize: 'sm'
    },
    md:{
      fontSize: 'md'
    },
    xl:{
      fontSize: 'xl',
      color:"red.400"
    },
  },
  variants:{
    beachte:{
     ml:4,
     color:'green.400'
    },
  }
}
const Heading= {
  baseStyle:{
    fontWeight:100,
   
    fontFamily: 'Roboto',
    
    fontSize: 'md'
  },
  sizes:{
    sm:{
      fontSize: 'sm'
    },
    md:{
      fontSize: 'md'
    },
    xl:{
      fontSize: 'md'
    },
  },
  variants:{
  verb:{
    color:"white",
    fontSize:["lg","lg","xl"],
  },
  Titel: {
    color: 'blue.300',
    fontSize: "xl",
    letterSpacing:'0.09rem',
    mt:10,
    mb:2,
      
  },
},
}
const theme=extendTheme({
  config,
  styles: {
    global:(props)=>(
      {
        'html,body':{
          fontSize:"1.15rem",
          bg:"blue.700"
        },
        a:{
          color: props.colorMode==="dark"?"white":"red",
        },
        

      }
    )
   
  },
  fonts:{
    heading: `'Roboto',sans-serif`,
    body: `'Roboto',sans-serif`,
  },
  components: {
    Text,
    Heading,
   
  }
})
export const wrapPageElement = ({ element }) => {
  return (
    <ChakraProvider theme={theme} resetCSS>
      <Layout>{element}</Layout>
    </ChakraProvider>
  )
}